var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.faqpage
    ? _c(
        "div",
        { staticClass: "w-100" },
        [
          _vm.checkIfCategoryHasQuestionsInLanguage("rovinieta")
            ? [
                _c(
                  "p",
                  { staticClass: "heading-medium", attrs: { id: "qv" } },
                  [_vm._v(_vm._s(_vm.capitalize(_vm.$tc("vignetteWord", 1))))]
                ),
                _vm._l(_vm.filteredItems, function (item) {
                  return item.rovinieta &&
                    _vm.getQuestionString(item, "title", "rovinieta")
                    ? _c("div", { staticClass: "wrapper" }, [
                        _c(
                          "div",
                          {
                            staticClass: "question-wrapper",
                            attrs: {
                              id: "question-wrapper-" + item.rovinieta.id,
                            },
                          },
                          [
                            _c(
                              "p",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.displayContent(item.rovinieta.id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "strong",
                                  { staticClass: "question-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getQuestionString(
                                          item,
                                          "title",
                                          "rovinieta"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "question-content",
                                attrs: { id: item.rovinieta.id },
                              },
                              [
                                _c("div", {
                                  staticClass: "answer",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getQuestionString(
                                        item,
                                        "answer",
                                        "rovinieta"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e()
                }),
              ]
            : _vm._e(),
          _vm.checkIfCategoryHasQuestionsInLanguage("tpf")
            ? [
                _c(
                  "p",
                  { staticClass: "heading-medium", attrs: { id: "qt" } },
                  [_vm._v(_vm._s(_vm.$tc("tollWord", 0)))]
                ),
                _vm._l(_vm.filteredItems, function (item) {
                  return item.tpf && _vm.getQuestionString(item, "title", "tpf")
                    ? _c("div", { staticClass: "wrapper" }, [
                        _c(
                          "div",
                          {
                            staticClass: "question-wrapper",
                            attrs: { id: "question-wrapper-" + item.tpf.id },
                          },
                          [
                            _c(
                              "p",
                              {
                                on: {
                                  click: function ($event) {
                                    return _vm.displayContent(item.tpf.id)
                                  },
                                },
                              },
                              [
                                _c(
                                  "strong",
                                  { staticClass: "question-title" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.getQuestionString(
                                          item,
                                          "title",
                                          "tpf"
                                        )
                                      )
                                    ),
                                  ]
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              {
                                staticClass: "question-content",
                                attrs: { id: item.tpf.id },
                              },
                              [
                                _c("div", {
                                  staticClass: "answer",
                                  domProps: {
                                    innerHTML: _vm._s(
                                      _vm.getQuestionString(
                                        item,
                                        "answer",
                                        "tpf"
                                      )
                                    ),
                                  },
                                }),
                              ]
                            ),
                          ]
                        ),
                      ])
                    : _vm._e()
                }),
              ]
            : _vm._e(),
        ],
        2
      )
    : _c(
        "div",
        { staticClass: "w-100" },
        _vm._l(_vm.filteredItems, function (item) {
          return _vm.getQuestionString(item, "title")
            ? _c(
                "div",
                {
                  staticClass: "question-wrapper",
                  attrs: { id: "question-wrapper-" + item.id },
                },
                [
                  _c("div", { staticClass: "inner" }, [
                    _c(
                      "p",
                      {
                        on: {
                          click: function ($event) {
                            return _vm.displayContent(item.id)
                          },
                        },
                      },
                      [
                        _c("strong", { staticClass: "question-title" }, [
                          _vm._v(_vm._s(_vm.getQuestionString(item, "title"))),
                        ]),
                      ]
                    ),
                    _c(
                      "div",
                      {
                        staticClass: "question-content",
                        attrs: { id: item.id },
                      },
                      [
                        _c("div", {
                          staticClass: "answer",
                          domProps: {
                            innerHTML: _vm._s(
                              _vm.getQuestionString(item, "answer")
                            ),
                          },
                        }),
                      ]
                    ),
                  ]),
                ]
              )
            : _vm._e()
        }),
        0
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }